import * as React from "react";
import { forwardRef, memo } from "react";
const SvgEe = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 33 21", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M0 0h33v21H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h33v14H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#0072CE", d: "M0 0h33v7H0z" }));
const ForwardRef = forwardRef(SvgEe);
const Memo = memo(ForwardRef);
export default Memo;
